<template>
  <div id="main-app">
  <ToolBar :title="toolbarTitle" :color="toolbarColor"/>
  <v-content> 
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card class="mt-5">
            <v-card-title primary-title>
              <div>
                <div class="display-2">Política de Privacidade</div>
                <span class="grey--text headline">Sistema A5 Convites</span>
                <p class="mt-3">
                  Nós, da A5 Convites, estamos comprometidos em resguardar sua privacidade. 
                  O intuito deste documento é esclarecer quais informações são coletadas dos usuários de nosso sistema e de que forma esses dados são manipulados e utilizados.
                </p><p>
                  Alertamos que se você não concorda com o conteúdo desta política, não é recomendável utilizar quaisquer de nossos serviços.
                </p>
              </div>
            </v-card-title>
            <v-card-text>
              <h2 class="display-1">Sobre a coleta de dados</h2>
              <p>Em nossos sites, as informações são coletadas das seguintes formas:
              </p>
              <p>
                  Informações fornecidas por você – Coletamos informações de identificação pessoal – como nome, telefone, email – via preenchimento dos formulários no sistema.
              </p>
              <p>
                Informações de navegação no site – Quando você visita nosso site, é inserido um ‘cookie’ no seu navegador por meio do software Google Analytics, para identificar quantas vezes você retorna ao nosso endereço. 
                São coletadas, anonimamente, informações, como endereço IP, localização geográfica, fonte de referência, tipo de navegador, duração da visita e páginas visitadas.
              </p>

              <h2 class="display-1 mt-3">Sobre o uso de suas Informações Pessoais</h2>
              <p>
              Suas informações pessoais serão usadas na impressão do seu convite de formatura
              </p>
              <ul>
                <li>
                1. A conferência e revisão dos textos individuais enviados para o Sistema são de inteira responsabilidade do Usuário. Não há correção ortográfica para os textos cadastrados. Sendo assim, sugerimos a utilização de um corretor ortográfico de sua confiança, antes de cadastrar seu texto no Sistema.
                </li>
                <li>
                2. A escolha das fotos de pais e crianças enviadas pelo Usuário é de sua inteira responsabilidade. O Usuário consente que a qualidade, enquadramento e produção das fotos enviadas são de inteira responsabilidade dos amadores ou profissionais que as produziram, sendo certo que não nos responsabilizamos pela qualidade das fotos fornecidas pelo Usuário.
                </li>
                <li>
                3. O Usuário se compromete a não enviar material ilegal ou que atente contra o direito de personalidade e intimidade de terceiros divulgando imagens que causem ou possam causar qualquer espécie de constrangimento ou danos à reputação de tais pessoas.
                </li>
                <li>
                4. Caso o Usuário permita o compartilhamento de sua senha e/ou acesso à terceiros, deverá assumir integral responsabilidade pelas ações e omissões praticadas por estas pessoas.
                </li>
              </ul>
              <p>
              </p>
              <p>
              O email poderá ser usado para envio de Newsletters, sempre relacionadas ao tema do seu convite.
              </p>
              <h2 class="display-1 mt-3">Mudanças na Política de Privacidade</h2>
              <p>Essa Política de Privacidade pode passar por atualizações. Desta forma, recomendamos visitar periodicamente esta página para que você tenha conhecimento sobre as modificações.
              </p>
              <p>
              Antes de usar informações para outros fins que não os definidos nesta Política de Privacidade, solicitaremos sua autorização.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" dark large @click='logOut'>Sair</v-btn>
              <v-spacer></v-spacer>
              <v-btn to="dados" dark color="teal">
                <span>Continuar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar";
export default {
  name: "AppPrivacidade",
  components: {
    ToolBar
  },
  data() {
    return {
      toolbarTitle: "A5 Convites",
      toolbarColor: "white",
      usuario: {},
      user: {},
      emailkey: ""
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.emailkey = user.email.replace(/[.]/g, ",");
      }
    });
  },
  methods: {
    logOut() {
      this.$auth.signOut().then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style lang="stylus">
.icon-warning {
  font-size: 100px !important;
  color: #dd2121 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AppPrivacidade.vue